module.exports = __webpack_public_path__ + "static/1166044116-square.cc43f7e4.jpg";